import placeholder from '../images/profile-photo-placeholder.svg'

const Teams = [
    {
        id: '1',
        title: 'Dr. Zakir Hussain Syed',
        subtitle: 'Chairperson',
        slug: 'zakir-hussain-syed',
        timg: placeholder,
        Sime: placeholder,
    },
    {
        id: '2',
        title: 'Adnan Saeed',
        subtitle: 'Director of Development',
        slug: 'adnan-saeed',
        timg: placeholder,
        Sime: placeholder,
    },
    {
        id: '3',
        title: 'Aly Al Rehman',
        subtitle: 'Director of Secretarial Matters',
        slug: 'aly-al-rehman',
        timg: placeholder,
        Sime: placeholder,
    },
    {
        id: '4',
        title: 'Anwar Dulloo',
        subtitle: 'Director of Treasury',
        slug: 'anwar-dulloo',
        timg: placeholder,
        Sime: placeholder,
    },
    {
        id: '5',
        title: 'Md. Rafeek Azath',
        subtitle: 'Director of Operations',
        slug: 'rafeek-azath',
        timg: placeholder,
        Sime: placeholder,
    },

]

export default Teams;



